import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import CustomInput from '../../../components/Elements/input/customInput';
import ChooseUserOption from '../../chooseUserBuy/chooseUser/chooseUserOption/chooseUserOption';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import p24 from "../../../assets/images/przelewy24_logo_materialy_graficzne/Przelewy24_logo.png"
// import Discount from '../discount/discount';
import PromotionsService from '../../../services/PromotionsService';
import UserDetailPopUp from '../../../components/Elements/userDetailPopUp/userDetailPopUp';
import AcceptInput from '../../chooseUserBuy/accept/accept';

import CourseDetail from '../../coursDetail/courseDetail';
import ApiService from '../../../services/ApiService';
import { API_URL } from '../../../config';
import axios from 'axios';

 
const   PaymentMethod = (props) => {
    const apiService = ApiService.getInstance();
    let [choosenPaymentOption, setChoosenPaymentOption]=useState(
        {
        apple:false,
        google:false,
        blik:false,
        debetCard: false,
        przelewy24: false,
        payPo:false}
    )
    let [isOwnDiscount, setOwnDiscount]=useState(false)
    let [nip, setNip] = useState(false)
    const [paymentAvailable, setPaymentAvailable] = useState([])
    let [isNipValid, setIsNipValid]= useState(true)
    let [showMsg,setShowMsg]=useState(false)
    let [discount, setDiscount] = useState([])
    const history = useHistory();
    let parcipientName =  localStorage.getItem('userName');   
    if(parcipientName == null){
        parcipientName =  localStorage.getItem('payerName');    
    }
    const promotionsService =new PromotionsService();
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    let userID = localStorage.getItem('participantUsersID')
    let userIDMain = localStorage.getItem('usersID')
    let courseHeadingId = localStorage.getItem('coursesHeadingsID')
  let localizationsID=localStorage.getItem('localizationsID')

    let varaintHint;
    let discountCode;
    let nipCode;
    const [nipValue, setNipValue] = useState("");
    let [promotionCode, setPromotionCode]=useState(false)
    let paymentMethodListForNoDuble = []



    // function setDiscounts(discount){
    //     if(discount.success){
    //         setDiscount(discount.fullData)
    //         props.setDiscountList(discount.fullData)
          
    //     }
    // }

// function getDiscountFromCode(e){
//     e.preventDefault()
//     let user = userID;
//     if(userID == null){
//         user = userIDMain
//     }
//     const payload = {
//         keyController: 'promotionCode',
//         promotionCode: discountCode,
//         current_LocalizationsID: '0',
//         usersID:user,
//     };
//     apiService.apiPost('CalculateProductForUser', payload, (response) => {
//         if (response.success) {
//             //
//             localStorage.setItem("Coupon",discountCode)
//             let arr = response.data.responseBody.body;
//            props.setPromotionsSalesID(arr[0].PromotionsSalesID)
//            promotionsService.getPromotions( user, 
//             courseHeadingId,props.data.productID,"5",props.choosenPaymentType,setDiscounts);
//           setPromotionCode(true)
//           setOwnDiscount(false)
//           props.discountList.forEach((dis)=>{
        
//             if(dis.promotionsSalesID == arr[0].PromotionsSalesID){
   
//                 localStorage.setItem("discountName", dis.promotionsSalesName)
        
//                 props.discount(dis)
//             }
//           })
//         }
//     });

// }

    function debetCardChoose(arg){
        setPromotionCode(false)
        setShowMsg(false)
        props.setPayP24(arg)
        if(props.paymentMethodList.debetCard){
           
        }else{
            props.setPaymentMethodList({
                apple:false,
                google:false,
                blik:false,
                debetCard: true,
                przelewy24: false,
                payPo:false
            })
            props.onChoose("6")
          
        }
      
        
        
    }
    function przelewyChoose(arg){
        setPromotionCode(false)
        setShowMsg(false)
        props.setPayP24(arg)
        if(props.paymentMethodList.przelewy24){
           
        }else{
            props.setPaymentMethodList({
             apple:false,
                google:false,
                blik:false,
                debetCard: false,
                przelewy24: true,
                payPo:false
        });
        props.onChoose("5")
       }
        
        
    }
    function appleChoose(arg){
        setPromotionCode(false)
        setShowMsg(false)
        if(props.paymentMethodList.apple){
            
            props.onChoose("")   
        }else{
            props.setPaymentMethodList({
            apple:true,
            google:false,
            blik:false,
            debetCard: false,
            przelewy24: false,
            payPo:false
        });
        props.onChoose("5")
        }
        
        
    }
    function googleChoose(arg){
        props.setPayP24(arg)
        setPromotionCode(false)
        setShowMsg(false)
        if(props.paymentMethodList.google){
        
            props.onChoose("")   
        }else{
            props.setPaymentMethodList({
            apple:false,
            google:true,
            blik:false,
            debetCard: false,
            przelewy24: false,
            payPo:false
        });
        props.onChoose("5")
        }
        
        
    }
    function blikChoose(arg){
        props.setPayP24(arg)
        setPromotionCode(false)
        setShowMsg(false)
        if(props.paymentMethodList.blik){
          
            props.onChoose("")   
        }else{
            props.setPaymentMethodList({
            apple:false,
            google:false,
            blik:true,
            debetCard: false,
            przelewy24: false,
            payPo:false
        });
        props.onChoose("5")
    
        }
        
        
    }
    function nextWithExtraData(){
        // 
        // let dataString = "";
        // if(props.discountD.length != 0){
        //     dataString +=  props.discountD.promotionsDiscountsID + "/";
        // }else{
        //     dataString +=  "/";
        // }
        // for (const [key, value] of Object.entries(props.paymentMethodList)) {
        //     if(value){
        //         dataString += key + "/"
        //     }
        // }
        // dataString += props.nip

        if(props.paymentP24 != undefined){
            if(nip){
                setIsNipValid(false)
            }
            else{props.next()}
        }else{
            setShowMsg(true)
        }
    }
    function payPoChoose(arg){
        props.discount([])
        props.setPayP24(arg)
        setPromotionCode(false)
        setShowMsg(false)
        if(props.paymentMethodList.payPo){
           
            props.onChoose("")   
        }else{
            props.setPaymentMethodList({
            apple:false,
            google:false,
            blik:false,
            debetCard: false,
            przelewy24: false,
            payPo:true
        });
        props.onChoose("5")
        promotionsService.getPromotions( userID, 
            courseHeadingId,props.data.productID,"5",props.choosenPaymentType
          );}
        
        
    }
    function firstButtonClick(event, name, discount){

        localStorage.setItem("discountName", name.promotionsSalesName)

        event.preventDefault()
        setPromotionCode(false)
        if(props.discountD.length == 0){props.discount(name)}
        else if(props.discountD.promotionsSalesID == name.promotionsSalesID){props.discount([])}
        else{props.discount(name)}
    }

    function secundButtonClick(event){
        event.preventDefault()
     
    }
    const payload = {
        keyController:"downloadAllPaymentMethods",
        localizationsID: "98",
        current_LocalizationsID: "0",
        amount:props.choosenPayVarian.currentPrice
    }
  useEffect(()=>{
    window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'checkout',
            'step' : `Metoda płatności`
        });
    
        apiService.apiPost('CalculateProductForUser', payload, (response) => {
       
          if(response.success){
            if(response.data.responseBody.body.data != undefined){
            setPaymentAvailable(response.data.responseBody.body.data)}else{
                setPaymentAvailable([]) 
            } }
            else{
                setPaymentAvailable([]) 
            }
      });

    //   if(props.choosenPayment == undefined){
    //     props.onChoose("5")
    //     props.setPayP24("p24")
    //     props.setPaymentMethodList({
    //         apple:false,
    //         google:false,
    //         blik:false,
    //         debetCard: false,
    //         przelewy24: true,
    //         payPo:false
    //     });
    //     //promotionsService.getPromotions
    //     let user = userID;
    //     if(userID == null){
    //         user = userIDMain
    //     }
    //     promotionsService.getPromotions( user, 
    //         courseHeadingId,props.data.productID,"5",props.choosenPaymentType
    //       );
    //   }
  },[])
    
    return <> 
    <div className='payment_wrapper'>
    <div className='payment_wrapperOptions'>
        <div className='payment_wrapper_option'>
            
            <CustomTittle>Wybierz formę płatności</CustomTittle>
                <div className='choosePaymentOption'>
                {paymentAvailable?.map((payMetod)=>{
                    if(payMetod.status){
                        if(payMetod.name == "BLIK"&&!paymentMethodListForNoDuble.includes(payMetod.name)){
                            paymentMethodListForNoDuble.push(payMetod.name)
                            return  <div className='paymentForm_label'>
                            <ChooseUserOption paymentOption={payMetod.id} isChekcked={props.paymentMethodList.blik} onCheck={blikChoose}></ChooseUserOption>
                                <div className='paymentForm_label_icon'>
                                <img className='"iconlogo' src={payMetod.imgUrl} width="48"></img>
                                </div>
                                
                                <p>BLIK</p>
                        </div>
                        }
                        //Kart płatniczna 
                        // else if(payMetod.name == "Credit Card"&&!paymentMethodListForNoDuble.includes(payMetod.name)){
                        //     paymentMethodListForNoDuble.push(payMetod.name)
                        //     return <div className='paymentForm_label'>
                        //     <ChooseUserOption paymentOption={payMetod.id} isChekcked={props.paymentMethodList.debetCard} onCheck={debetCardChoose}></ChooseUserOption>
                        //         <div className='paymentForm_label_icon'>
                        //         <img className='"iconlogo' width="60" src={payMetod.imgUrl}></img>
                        //         </div>
                                
                        //         <p>Karta kredytowa</p>
                        // </div>
                        // }
                        else if(payMetod.name == "Google Pay"&&!paymentMethodListForNoDuble.includes(payMetod.name)){
                            paymentMethodListForNoDuble.push(payMetod.name)
                            return <div className='paymentForm_label'>
                            <ChooseUserOption paymentOption={payMetod.id} isChekcked={props.paymentMethodList.google} onCheck={googleChoose}></ChooseUserOption>
                                <div className='paymentForm_label_icon'>
                                <img className='"iconlogo' src={payMetod.imgUrl} width="48"    ></img>
                                </div>
                                
                                <p>GooglePay</p>
                        </div>
                        }
                        else if(payMetod.name == "ApplePay"&&!paymentMethodListForNoDuble.includes(payMetod.name)){
                            paymentMethodListForNoDuble.push(payMetod.name)
                            return <div className='paymentForm_label'>
                            <ChooseUserOption paymentOption={payMetod.id} isChekcked={props.paymentMethodList.apple} onCheck={appleChoose}></ChooseUserOption>
                                <div className='paymentForm_label_icon'>
                                <img className='"iconlogo' src={payMetod.imgUrl}
                                width="48" 
                                ></img>
                                </div>
                                
                                <p>ApplePay</p>
                        </div>
                        }
                        else if(payMetod.name == "PayPo"&&!paymentMethodListForNoDuble.includes(payMetod.name)){
                            paymentMethodListForNoDuble.push(payMetod.name)
                            return <div className='paymentForm_label'>
                            <ChooseUserOption paymentOption={payMetod.id} isChekcked={props.paymentMethodList.payPo} onCheck={payPoChoose}></ChooseUserOption>
                            <div className='paymentForm_label_icon'>
                            <img className='"iconlogo' src={payMetod.imgUrl} width="60"></img>
                            </div>
                            <p>PayPo - kup teraz, zapłać za 30 dni</p>
                        </div>
                        }
                    }
                })}
                
                        
                       
{/*                        
                        <div className='paymentForm_label'>
                            <ChooseUserOption paymentOption={"p24"} isChekcked={props.paymentMethodList.przelewy24} onCheck={przelewyChoose}></ChooseUserOption>
                            <div className='paymentForm_label_icon'>
                            <img className='"iconlogo' src={p24}></img>
                            </div>
                            <p>Przelewy24</p>
                        </div> */}
                        
                </div>
               
            {showMsg?<p className="errorMsg">Wybierz metode płatności</p>:""}
        {/* <div className='discountCode'>
        {props.discountList.length != 0? <div className='choosenPayment_Sales'>
                    <CustomTittle>Aktywne promocje do umowy</CustomTittle>
                    <div className='dicountBox'>
                    {props.discountList.map((dis)=>{
                     
                        if(dis.activationTypeDVID != 3||dis.promotionsSalesID == props.promotionsSalesID){
                    return  <Discount unClickElement={props.discountD.promotionsSalesID == dis.promotionsSalesID} choose={firstButtonClick} discount={dis} tittle={dis.promotionsSalesName}></Discount>}
                    })}
                    
                
                    
                </div>
            </div>:""}
            <AcceptInput unClickElement={isOwnDiscount} onAccept={(e)=>{setOwnDiscount(!e)}} label="Posiadam kod rabatowy"></AcceptInput>
            <div className='discountCode_enter'>

           {isOwnDiscount?<CustomInput onChangeInput={(e)=>{discountCode=e}} title={"Kod rabatowy"} icon={
                <CustomButtons clickFunction={(e)=>{getDiscountFromCode(e)}} classButton="solid" size="small" >ZATWIERDŹ</CustomButtons>  
            }></CustomInput>:""}  
            
            {promotionCode?<p className="discountMsg">Kod rabatowy został zatwierdzony</p>:""}
        </div>       
        </div> */}
       <div className='nip marginTop20'>
            <CustomTittle>Potrzebuję faktury VAT</CustomTittle>
            <div className='nip_checkbox'>
            <AcceptInput onAccept={(e)=>{setNip(!e);setIsNipValid(true);setNipValue("")}} label="NIP do paragonu"></AcceptInput>
            {nip?<CustomInput
            hint="Nip składa się z 10 cyfr"
            showCalendary={() => {
                if (!isNipValid) {
                    setIsNipValid(true)
                }
            }}
            validation={isNipValid} onChangeInput={(e)=>{
                nipCode = e.replaceAll(' ', ''); 
                nipCode = nipCode.replaceAll('-', '');
                
                }} title={"NIP"} isRequied={true}
                icon={
                    <CustomButtons clickFunction={(e)=>
                       { let value = nipCode
                        if (/^\d+$/.test(value) && value.length == 10){
                            setNip(false)
                            props.setNip(value)
                            setNipValue(value)
                            setIsNipValid(true)
                        }
                        else{
                            setIsNipValid(false)
                        }}} classButton="solid" size="small" >ZATWIERDŹ</CustomButtons>  
                }></CustomInput>:""}  
                {nipValue != ""? <p className="info">Dodano numer nip: {nipValue}</p>:""}           
            </div>    
        </div> 
        <CustomButtons clickFunction={()=>{if(isNipValid){nextWithExtraData()}}} classButton="solid" size="big" >PRZEJDŹ DALEJ</CustomButtons>
        </div>
        </div>
        <div className='columDetials_payment'>
            <div className='columDetials_wrapper'>
                        <CustomTittle>Szczegóły zamówienia  </CustomTittle>
                        <CourseDetail
                            wrapNavigator={props.wrapNavigator}
                            setWrapNavigator={props.setWrapNavigator}
                            setHeader={(e) => {
                                props.setHeader(e);
                            }}
                            header={props.header}
                        ></CourseDetail>
                        <UserDetailPopUp
                                
                                title="Wariant cenowy:"
                                label={
                                    "płatność ratalna"
                                }
                                onclick={()=>{props.setNavigator(2)}}
                                icon={<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z" fill="#CC0033"/>
                </svg>
                }
                               
                    ></UserDetailPopUp>
            </div>
        </div>
       
    </div>
    </>;
    }

export default PaymentMethod;
